module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/colorpicker/colopicker.component.html
// module id = KDSV
// module chunks = 12